module.exports = __webpack_public_path__ + "img/ex-pin-music.39ed0009.svg";